import { getGroupDocumentPermission, getPublicDocumentPermission } from "@tuqqi/common";
import { managerTableKeepGlobalData } from "@tuqqi/web"
import { openInput as openNewUiInput } from '@tuqqi/web'
import { FULLVIEW_POST, INPUT_OPEN } from "../../../../../actionTypes/actionTypes";


const oldCase = (dataType, groupUid, setNumberToDispaly) => {
    const dispatch = managerTableKeepGlobalData.dispatchF;
    if(!dispatch) return
    const payload = { postText: '', dataType, permissions: [groupUid ?? ''] }

    dispatch({
        type: FULLVIEW_POST,
        openPost: true,
        item: payload
    })
    dispatch({ type: INPUT_OPEN, model: payload });
    setNumberToDispaly?.(4);
    dispatch({ type: 'BLUR_CREATENEW_MODAL' })
}

export const openNewInputItem = (dataType, groupUid, setNumberToDispaly) => {
    const dispatch = managerTableKeepGlobalData.dispatchF;
    if(!dispatch) return

    if(['poll', 'question'].includes(dataType)) {
        oldCase(dataType, groupUid, setNumberToDispaly)
        return
    }

    const permissions = !!groupUid ? getGroupDocumentPermission(groupUid) : getPublicDocumentPermission()
    let newDoc = { html: '', title: '', permissions: permissions, dataType: dataType }
    dispatch(openNewUiInput(newDoc, dataType))
    setNumberToDispaly?.(4);
    dispatch({ type: 'BLUR_CREATENEW_MODAL' })
}